const initialState = {
  loading: false,
  loaded: false,
  submitting: false,
  successful: false,
  pinkSlipAdresses: [],
  pinkSlipAdress: null,
}

export default function(state = initialState, action = {}) {
  switch (action.type) {
    case 'GET_PINK_SLIPS': {
      return {
        ...state,
        loading: true,
      }
    }

    case 'GET_PINK_SLIPS_COMMIT': {
      return {
        ...state,
        loading: false,
        loaded: true,
        pinkSlipAdresses: action.payload.addresses || [],
      }
    }

    case 'GET_PINK_SLIPS_ROLLBACK': {
      return {
        ...state,
        loading: false,
        loaded: false,
        pinkSlipAdresses: [],
      }
    }

    case 'SEND_PINK_SLIPS': {
      return {
        ...state,
        submitting: true,
      }
    }

    case 'SEND_PINK_SLIPS_COMMIT': {
      return {
        ...state,
        submitting: false,
        successful: true,
      }
    }
    case 'SEND_PINK_SLIPS_ROLLBACK': {
      return {
        ...state,
        submitting: false,
        successful: false,
        pinkSlipAdress: null,
      }
    }

    case 'SET_PINK_SLIP_ADDRESS': {
      return {
        ...state,
        pinkSlipAdress: action.payload.address,
      }
    }

    default: {
      return state
    }
  }
}
